import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaAngleDown } from "react-icons/fa";
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { FaGlobe } from 'react-icons/fa';

const Nav = () => {
    const { t } = useTranslation();
    // Use useState to manage the current language within the component
    // Initialize with i18n.language which will be detected by i18next
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

    // Effect to update currentLanguage if i18n.language changes externally
    useEffect(() => {
        const handleLanguageChange = (lng) => {
            setCurrentLanguage(lng);
        };
        i18n.on('languageChanged', handleLanguageChange);

        // Cleanup listener on component unmount
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);

    const selectlanguage = async () => {
        const inputOptions = new Promise((resolve) => {
            resolve({
                'pt': generateLanguageOption('Português', 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_Portugal.svg/255px-Flag_of_Portugal.svg.png'),
                'en': generateLanguageOption('English', 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Flag_of_the_United_Kingdom_%281-2%29.svg/255px-Flag_of_the_United_Kingdom_%281-2%29.svg.png'),
                'es': generateLanguageOption('Español', 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Bandera_de_Espa%C3%B1a.svg/255px-Bandera_de_Espa%C3%B1a.svg.png'),
                'fr': generateLanguageOption('Français', 'https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/250px-Flag_of_France.svg.png'),
                'it': generateLanguageOption('Italiano', 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Flag_of_Italy.svg/255px-Flag_of_Italy.svg.png')
            });
        });

        function generateLanguageOption(languageName, flagImageUrl) {
            return `<div style="display: flex; flex-direction: column; align-items: center;">${languageName}</div><div style="display: flex; justify-content: center;"><img src="${flagImageUrl}" style="height: 40px; width: auto;" /></div>`;
        }

        const result = await Swal.fire({
            title: t('Select a language'),
            input: 'radio',
            // Use the currentLanguage state for inputValue
            inputValue: currentLanguage,
            inputOptions: inputOptions,
            customClass: 'customClassModalLinguas',
            inputValidator: (value) => {
                if (!value) {
                    return t('obrigatorio_escolher_opcao');
                }
            }
        });

        if (result.isConfirmed) {
            const selectedLanguage = result.value;
            // IMPORTANT: Use the consistent key 'language' here
            localStorage.setItem('language', selectedLanguage); // Store the language value in LocalStorage

            i18n.changeLanguage(selectedLanguage, (err, t) => {
                if (err) return console.error('something went wrong loading the language', err);
                // The languageChanged event listener in useEffect will update currentLanguage state
            });
        }
    };

    return (
        <nav className="mainmenu-nav">
            <ul className="mainmenu">
                <li className="menu-item-has-children">
                    <Link to="#">{t('services')}<FaAngleDown /></Link>
                    <ul className="axil-submenu">
                        {/* Note: Directly rendering a translation key like {t('Electricité')} outside of a <li> or similar element might not render visually as expected, depending on your CSS. */}
                        <li>{t('Electricité')}</li> {/* Added <li> for better structure */}
                        <li><Link to={"/service-Courant_Fort"}>{t('courantfort')}</Link></li>
                        <li><Link to={"/service-Courant_Faible"}>{t('courantfaible')}</Link></li>
                        <li><Link to={"/service-Audiovisuel"}>{t('Audiovisuel')}</Link></li>
                        <li><Link to={"/service-Securite"}>{t('Securite')}</Link></li>
                        <hr style={{ margin: "0" }}></hr>
                        <li>{t('Energie renouvelable')}</li> {/* Added <li> for better structure */}
                        <li><Link to={"/service-Productiondenergie"}>{t('Production d\'énergie')}</Link></li>
                        <li><Link to={"/service-Stockagedenergie"}>{t('Stockage d\'énergie')}</Link></li>
                        <li><Link to={"/service-Gestiondenergie"}>{t('Gestion d\'énergie')}</Link></li>
                        <li><Link to={"/service-Maintenance"}>{t('Maintenance')}</Link></li>
                        <hr style={{ margin: "0" }}></hr>
                        <li>{t('Informatique')}</li> {/* Added <li> for better structure */}
                        <li><Link to={"/service-Developpement"}>{t('Developpement')}</Link></li>
                        <li><Link to={"/service-Creative-Branding"}>{t('Service Creative & Branding')}</Link></li>
                        <li><Link to={"/service-ServiceItSolutions"}>{t('IT Solutions')}</Link></li>
                    </ul>
                </li>
                <li><Link to={"/lentreprise"}>{t('L\'entreprise')}</Link></li>
                <li><Link to={"/referance"}>{t('Referance')}</Link></li>
                <li><Link to={"/contact"}>{t('Contact')}</Link></li>
                {/* Display the current language next to the globe icon */}
                <li onClick={() => selectlanguage()} style={{ cursor: "pointer"}}><FaGlobe style={{ marginBottom: '2px' }} /> {t('language')} ({currentLanguage.toUpperCase()})</li>
            </ul>
        </nav>
    );
};

export default Nav;